import { FORM_VALUE_ENUM, FORM_VALUE_INTER } from './constant';

export const convert = (data: FORM_VALUE_INTER) => ({
  ...data,
  timezone:
    data[FORM_VALUE_ENUM.TIMEZONE] && Number(data[FORM_VALUE_ENUM.TIMEZONE]),
});
